export default "__VITE_ASSET__30eedbb7__"